export default{
    name: 'navBar',
    title: '顶栏',
    text: '我的主页',
    color: '#000000',
    bgColor: '#D6E8F9',
    transparent:true,
    fixed:false,
    showLeft:true,
    leftIcon:'wap-home-o',
    handle: 'none',
    message: '',
    link: '',
    path: '',
    //小程序页面
    appId: '' //小程序appId
}